import { getCommonImageAttributes } from '@/components/tiptap-editor/tiptap-extension/image-utils';
import { linkPastedLibraryImageFromUrl } from '@/lib/image-from-library';
import { nodePasteRule } from '@tiptap/core';
import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ZyImageNodeView from './zyimage-node-view';

/**
 * Escapes a string for use in a regular expression.
 */
const escapeForRegex = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const ZyImageHeadless = Image.extend({
    addAttributes() {
        return getCommonImageAttributes(this.parent);
    },

    addPasteRules() {
        return [
            nodePasteRule({
                find: text => {
                    const baseImageUrl = this.editor?.state.doc.attrs.baseImageUrl;

                    if (!baseImageUrl) {
                        return null;
                    }

                    const baseImageUrlRegex = new RegExp(`^${escapeForRegex(baseImageUrl)}\\S+$`);
                    const match = text.match(baseImageUrlRegex);

                    if (!match) {
                        return null;
                    }

                    return [{ index: 0, text: match[0] }];
                },
                type: this.type,
                getAttributes: match => {
                    const src = match[0];
                    const documentId = this.editor?.state.doc.attrs.documentId;
                    if (typeof documentId === 'number' && documentId > 0 && this.editor) {
                        void linkPastedLibraryImageFromUrl(this.editor, src, documentId);
                    }
                    return { src };
                },
            }),
        ];
    },
});

export const ZyImage = ZyImageHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyImageNodeView);
    },
});
